/**
 * Client Permission Levels
 *
 * Defines permission levels for client portal users.
 * Stored on each entry in user.companies[] as `permissionLevel`.
 * Enforced on the front end only (no Firestore rules changes).
 * Existing users without a permissionLevel default to Administrator.
 */

export const CLIENT_PERMISSION_LEVELS = {
  VIEW_ONLY: 'view-only',
  MANAGER: 'manager',
  // Held by agency staff on the companies their agency manages. Identical to
  // MANAGER today; it exists so agency-only rules become a constant change
  // rather than another `agencyId` special case. Never offered in a picker —
  // the agency Cloud Functions assign it.
  AGENCY: 'agency',
  ADMINISTRATOR: 'administrator'
}

export const PERMISSION_LABELS = {
  'view-only': 'View Only',
  'manager': 'Manager',
  'agency': 'Agency',
  'administrator': 'Administrator'
}

/**
 * Levels a user holding `level` may hand out. Nobody can grant above their own
 * level, and `agency` is system-assigned so it never appears here.
 */
export const ASSIGNABLE_LEVELS = {
  'view-only': [],
  'manager': ['view-only', 'manager'],
  'agency': ['view-only', 'manager'],
  'administrator': ['view-only', 'manager', 'administrator']
}

/**
 * Client routes blocked per permission level.
 * Routes not listed here are accessible to all levels.
 */
export const BLOCKED_ROUTES = {
  'view-only': [
    'account-upload',
    'account-company-details',
    'account-projects',
    'account-project-details',
    'account-calendar',
    'account-reviews',
    'account-conversations'
  ],
  // Managers and agency staff reach the company page for the Users tab; the
  // tabs they may not use are filtered out in CompanyDetails.vue instead.
  'manager': [],
  'agency': [],
  'administrator': []
}

/**
 * Routes blocked for "Vysual Only" companies.
 * These companies only have access to Asset Library, Upload, Sharing, and Company Settings.
 * This restriction applies to ALL users, including admins impersonating the company.
 */
export const VYSUAL_ONLY_BLOCKED_ROUTES = [
  'account-projects',
  'account-project-details',
  'account-calendar',
  'account-reviews',
  'account-shows',
  'account-show-detail',
  'account-episode-details'
]
